



























































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import flightService from "@/service/flightService";
import { Categorys, OrderStatus, AmendStatus, ActiveStatus, BusinessType, DealStatus } from "@/model/Base";
import orderInfo from "../orderInfo";
import { Step, Steps, NoticeBar } from "vant";
import _ from "lodash";
import LoadingFrame from "@/components/loadingFrame.vue";
import { FlightProductEntity, OrderEntity } from "@/model/Flight";

@Component({
  name: "flightOrderInfo",
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [NoticeBar.name]: NoticeBar,
  },
})
export default class FlightOrderInfo extends orderInfo {
  //props
  @Prop()
  showLogs?: boolean;

  @Prop()
  InsurancePrice?: any;

  @Prop()
  ChargePrice?: any;

  //data
  service = flightService;
  isShowPriceInfo = false;

  isShowChangeSolve = false;

  changeModel: any = null;
  showChangeSolve(change: any) {
    this.changeModel = change;
    this.isShowChangeSolve = true;
  }

  get resolveText() {
    if (this.amendOrder.BusinessType == BusinessType.Amend) {
      return { resolve: this.$root.$t("order_flight_flightorderinfo_yunxutuipiao") as string, reject: this.$root.$t("order_flight_flightorderinfo_jujuetuipiao") as string };
    }
    if (this.order.BusinessType == BusinessType.Change) {
      return { resolve: this.$root.$t("order_flight_flightorderinfo_yunxugaiqian") as string, reject: this.$root.$t("order_flight_flightorderinfo_jujuegaiqian") as string };
    }
    return { resolve: this.$root.$t("order_flight_flightorderinfo_shenpitongguo") as string, reject: this.$root.$t("order_flight_flightorderinfo_shenpijujue") as string };
  }

  changeSolve(ChangeID: string, isAgree: boolean) {
    flightService.changeSolve({ ChangeID: ChangeID, isAgree: isAgree }).then(p => {
      if (p.isSucc) {
        this.$emit("reload");
        this.isShowChangeSolve = false;
      }
    });
  }

  showRule = false;
  pdtRules = [] as string[];
  BagRules = [];
  showRules(value: any) {
    this.BagRules = this.matchBaggageExtra(this.order, value) as [];
    this.pdtRules = value.BackRule.split("；");
    this.pdtRules = this.translateDepartureTimeList(this.pdtRules);
    if (this.pdtRules.length < 1) {
      return;
    }

    this.showRule = true;
  }
  translateDepartureTimeList(list: string[]): string[] {
    return list.map(this.translateDepartureTime);
  } 
  translateDepartureTime(text: string): string {
    let result = text;

    const rules: Array<[RegExp, string]> = [
      // ===== 最具体（必须最先匹配）=====
      [/(\d+)小时至(\d+)天前/g, `$1 ${this.$t("order_flight_flightorderinfo_xiaoshizhi")} $2 ${this.$t("order_flight_flightorderinfo_tianqian")}`],
      [/(\d+)天至(\d+)天前/g, `$1 ${this.$t("order_flight_flightorderinfo_tianzhi")} $2 ${this.$t("order_flight_flightorderinfo_tianqian")}`],

      // ===== 手续费相关（新增）=====
      [/改签收取/g, `${this.$t("order_flight_flightorderinfo_gaiqianshouqu")}`],
      [/退票收取/g, `${this.$t("order_flight_flightorderinfo_tuipiaoshouqu")}`],
      [/的手续费/g, `${this.$t("order_flight_flightorderinfo_deshouxufei")}`],

      // ===== 明确时间尾部 =====
      [/小时前/g, `${this.$t("order_flight_flightorderinfo_xiaoshiqian")}`],
      [/小时之前/g, `${this.$t("order_flight_flightorderinfo_xiaoshizhiqian")}`],
      [/小时之后/g, `${this.$t("order_flight_flightorderinfo_xiaoshizhihou")}`],
      [/天之前/g, `${this.$t("order_flight_flightorderinfo_tianzhiqian")}`],
      [/天前/g, `${this.$t("order_flight_flightorderinfo_tianqian")}`],

      // ===== 起飞基准 =====
      [/起飞前/g, `${this.$t("order_flight_flightorderinfo_qifeiqian")}`],
      [/起飞后/g, `${this.$t("order_flight_flightorderinfo_qifeihou")}`],

      // ===== 单位兜底 =====
      [/小时/g, `${this.$t("order_flight_flightorderinfo_xiaoshi")}`],
      [/天/g, `${this.$t("order_flight_flightorderinfo_tian")}`],
    ];

    for (const [pattern, replacement] of rules) {
      result = result.replace(pattern, replacement);
    }

    return result;
  }

  getChangeStatus(value: number) {
    if (value == 10301) {
      return "待通知";
    } else if (value == 10303) {
      return this.$t("order_orderdetails_daiqueren");
    } else if (value == 10305) {
      return "已确认";
    } else if (value == 10307) {
      return "已处理";
    }
    return "未知状态";
  }

  showAirplane(airplane: string) {
    if (airplane) {
      if (airplane[0] == "7") {
        return `${this.$t("mall_flight_flightdetails_boyin")}${airplane}`;
      } else if (airplane[0] == "3") {
        return `${this.$t("mall_flight_flightdetails_kongke")}${airplane}`;
      } else if (airplane == "919") {
        return `C${airplane}`;
      }
    }
    return "";
  }
  extractExtra(code: string, order: OrderEntity, product: FlightProductEntity) {
    let extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == code && e.IncludeID == product.ProductID);
    return (extraInfo && extraInfo.ExtraData) || "";
  }
  showFoodExtra(order: OrderEntity, product: FlightProductEntity) {
    let extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode == "flight.FoodName" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      return extraInfo.ExtraData;
    }
    return "";
  }
  matchBaggageExtra(order: OrderEntity, product: FlightProductEntity) {
    let baggage = _.find(order.ExtraInfos, e => e.ExtraCode == "flight.baggages" && e.IncludeID == product.ProductID);
    if (baggage && baggage.ExtraData) {
      let bagObjs = JSON.parse(baggage.ExtraData) as any[];
      let carryonBag = bagObjs.find(o => o.BaggageCode == "1975");
      let consignBag = bagObjs.find(o => o.BaggageCode == "1976");
      let rules = [];
      if (carryonBag == null) {
        rules.push((this.$t("mall_flight_flightdetails_yihangsizuixinguidingweizhun") as string));
      } else if (carryonBag.Weight == 0 || (!carryonBag.Weight && !carryonBag.RuleDesc) || (!carryonBag.Weight && carryonBag.RuleDesc && carryonBag.RuleDesc.indexOf("无") >= 0)) {
        rules.push("无手提行李额");
      } else if (carryonBag.Weight) {
        let cubage = carryonBag.Width && carryonBag.height && carryonBag.Depth ? `体积不超过${carryonBag.Width}x${carryonBag.Height}x${carryonBag.Depth}CM;` : "";
        rules.push(`免费手提行李1件${carryonBag.Weight}${carryonBag.UnitCode};${cubage}`);
      } else {
        rules.push(`免费手提行李${carryonBag.RuleDesc}`);
      }
      if (consignBag == null) {
        rules.push((this.$t("mall_flight_flightdetails_yihangsizuixinguidingweizhun") as string));
      } else if (consignBag.Weight == 0 || (!consignBag.Weight && !consignBag.RuleDesc) || (!consignBag.Weight && consignBag.RuleDesc && consignBag.RuleDesc.indexOf("无") >= 0)) {
        rules.push("无托运行李额");
      } else if (consignBag.Weight) {
        let cubage = consignBag.Width && consignBag.height && consignBag.Depth ? `单件体积不超过${consignBag.Width}x${consignBag.Height}x${consignBag.Depth}CM;` : "";
        rules.push(`免费托运行李${consignBag.Weight}${consignBag.UnitCode};${cubage}`);
      } else {
        rules.push(`免费托运行李${consignBag.RuleDesc}`);
      }
      return rules;
    }
    return [];
  }

  showExtra(order: OrderEntity, product: FlightProductEntity) {
    let extras = [];
    let extraInfo = null;
    extraInfo = _.find(order.ExtraInfos, e => e.ExtraCode != "flight.FoodName" && e.IncludeID == product.ProductID);
    if (extraInfo && extraInfo.ExtraData) {
      extras.push(extraInfo.ExtraData);
    }
    return extras.join("|");
  }
}
